export default __webpack_public_path__ + "25445194c20d64f7abad39f3746efdf3.png";